<template>
    <Component
        :is="element"
        unstyled
        class="base-button"
        :class="{
            'base-button--primary': !secondary && !transparent && !outlined,
            'base-button--secondary': secondary,
            'base-button--transparent': transparent,
            'base-button--outlined': outlined,
            'base-button--small': small,
            'base-button--large': large,
            'base-button--responsive': !small && !large,
            'base-button--icon-only': icon && (!label || iconOnly),
            'base-button--with-icon': icon,
            'base-button--hover': hover,
            'base-button--loading': loading
        }"
    >
        <Icon v-if="activeIcon && (iconPosition === 'left' || (isMarkerIcon && label && !iconOnly))" class="left" :name="activeIcon" />
        <span>
            {{ label }}
        </span>
        <Icon v-if="activeIcon && (iconPosition === 'right' || (isMarkerIcon && label && !iconOnly))" class="right" :name="activeIcon" />
    </Component>
</template>

<script setup>
const props = defineProps({
    element: {
        type: [String, Object],
        required: false,
        default: 'button'
    },
    secondary: {
        type: Boolean,
        default: false
    },
    transparent: {
        type: Boolean,
        default: false
    },
    outlined: {
        type: Boolean,
        default: false
    },
    small: {
        type: Boolean,
        default: false
    },
    large: {
        type: Boolean,
        default: false
    },
    icon: {
        type: String,
        default: null
    },
    iconPosition: {
        type: String,
        default: 'right'
    },
    iconOnly: {
        type: Boolean,
        default: false
    },
    hover: {
        type: Boolean,
        default: false
    },
    loading: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        default: null
    }
});

const { loading, icon } = toRefs(props);

const activeIcon = computed(() => {
    if (loading.value) {
        return 'app:activity_progress';
    } else {
        return icon.value;
    }
});

const isMarkerIcon = computed(() => activeIcon.value?.startsWith('marker:'));
</script>

<style src="./BaseButton.less" lang="less" />
